import script from "./ResultTableColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultTableColumn.vue?vue&type=script&setup=true&lang=ts"

import "./ResultTableColumn.vue?vue&type=style&index=0&id=7dc4bc00&lang=scss&scoped=true"

import exportComponent from "/builds/ext/ERCO/productdata-archive-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc4bc00"]])

export default __exports__